module.exports = __webpack_public_path__ + "img/de.77cad377.png";